import { Link } from 'react-router-dom';
import type { Anime } from '@/mocks/anime';

interface AnimeCardProps {
  anime: Anime;
  showCategory?: boolean;
  showRating?: boolean;
}

export default function AnimeCard({ anime, showCategory = true, showRating = true }: AnimeCardProps) {
  const categoryMap: Record<string, string> = {
    rexue: '热血',
    lianai: '恋爱',
    qihuan: '奇幻',
    gaoxiao: '搞笑',
    xuanyi: '悬疑',
    richang: '日常',
    zhandou: '战斗',
    kehuan: '科幻',
  };

  return (
    <Link
      to={`/anime/${anime.id}`}
      className="group block cursor-pointer"
      data-product-shop
    >
      <div className="relative overflow-hidden rounded-xl aspect-[3/4] mb-3">
        <img
          src={anime.cover}
          alt={anime.title}
          title={`${anime.title} - 91动漫高清在线观看`}
          className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-end p-3">
          <span className="text-xs text-white/90 bg-primary-500/90 px-2.5 py-1 rounded-full whitespace-nowrap">
            立即观看
          </span>
        </div>
        {anime.status === '连载中' && (
          <div className="absolute top-2 left-2">
            <span className="text-[10px] font-medium text-background-50 bg-accent-500 px-2 py-0.5 rounded-full whitespace-nowrap">
              连载中
            </span>
          </div>
        )}
        <div className="absolute bottom-2 right-2">
          <span className="text-[10px] text-white/80 bg-black/50 px-2 py-0.5 rounded-full whitespace-nowrap">
            更新至{anime.updatedEpisode}集
          </span>
        </div>
      </div>
      <h3 className="text-sm font-medium text-foreground-950 group-hover:text-primary-600 transition-colors line-clamp-1 mb-1">
        {anime.title}
      </h3>
      <div className="flex items-center gap-2 text-xs text-foreground-500">
        {showCategory && (
          <span className="bg-secondary-100 text-secondary-700 px-1.5 py-0.5 rounded whitespace-nowrap">
            {categoryMap[anime.category] || anime.category}
          </span>
        )}
        {showRating && (
          <span className="flex items-center gap-0.5 whitespace-nowrap">
            <i className="ri-star-fill text-amber-400 text-xs"></i>
            {anime.rating}
          </span>
        )}
      </div>
    </Link>
  );
}